<template>
	<!-- 关于我们 -->
	<div class="about">
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
				<div class="bannerCont">
					<p class="p1">智慧停车解决方案</p>
					<p class="p2">客户至上 创新驱动 追求卓越 开放合作</p>
				</div>
			</div>
			<!-- 位置 -->
			<div class="public site">
				<span class="square"></span>
				<p>您的位置： 首页  <span>></span>   解决方案</p>
			</div>
			<!-- 简介/荣誉 -->
			<div class="public solution">
				<div class="left">
					<p class="center">解决方案中心</p>
					<ul>
						<li v-for="(tab,index) in tabs" @click="toggle(index,tab.view)" :class="{active:active==index}" :key="index">
							{{tab.type}}
							<div :class="{sangle:active==index}"></div>
						</li>
					</ul>
				</div>
				<div class="right">
					<!--:is实现多个组件实现同一个挂载点-->
					<component :is="currentView"></component>
				</div>
			</div>
		</div>
		<!-- bottom -->
		<footers></footers>
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	import tab1 from '@/components/process/tab1.vue'
	import tab2 from '@/components/process/tab2.vue'
	import tab3 from '@/components/process/tab3.vue'
	export default{
		data(){
			return{
				active:0,
				currentView:'tab1',
				tabs:[
					{
					  type:'路内停车',
					  view:'tab1'
					},
					{
					  type:'路外停车',
					  view:'tab2'
					},
					{
					  type:'共享停车',
					  view:'tab3'
					}
				]
			}
		},
		methods:{
		    toggle(i,v){
				this.active=i;
				this.currentView=v;
		    }
		},
		components:{
			headers,footers,
			tab1,
			tab2,
			tab3
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.banner{
		width: 100%;
		height:540px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		background: url(../../assets/images/processBack.png) center no-repeat;
		background-size: 100% 100%;
		text-align: center;
		.bannerCont{
			width:600px;
			height: 380px;
			padding-top: 200px;
			color: #fff;
			margin: 0 auto;
			text-align:center;
			.p1{
				width: 600px;
				border-top:1px solid #fff ;
				font-size: 40px;
				padding: 10px;
				font-weight: bold;
			}
			.p2{
				width: 600px;
				font-size:30px;
				padding: 10px;
				border-bottom:1px solid #fff ;
			}
		}
	}
	.public{
		width: 1200px;
		margin: 0 auto;
	}
	.site{
		height: 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: left;
		font-size:16px;
		color:#333;
		margin: 30px auto;
		border-bottom:1px dashed #ccc;
		.square{
			display: inline-block;
			width: 10px;
			height: 20px;
			background: #000;
			margin-right: 10px;
		}
		p{
			span{
				padding: 0 5px;
			}
		}
	}
	.solution{
		display:flex;
		justify-content: space-between;
		flex-direction:row;
		.left{
			width:240px;
			.center{
				width: 100%;
				height: 76px;
				background: #3C77F0;
				line-height: 76px;
				color: #fff;
				border-bottom: 1px solid #fff;
			}
			li{
				width:240px;
				height:56px;
				line-height: 56px;
				background: #ececec;
				cursor:pointer;
				display: inline-block;
				border-bottom:1px dashed #ccc ;
			}
			li.active{
				background:#3c77f0;
				color: #fff;
			}
		}
		.right{
			margin-left: 60px;
			width: 900px;
			text-align: center;
		}
		
	}
</style>



// WEBPACK FOOTER //
// src/views/solution/solution.vue